<template>
    <label>
        <h3>{{ label }}</h3>
        <hr />
    </label>
</template>

<script>
export default {
    props: ["label"]
};
</script>

<style lang="scss" scoped>
label {
    display: flex;
    margin-bottom: 15px;

    > :first-child {
        font-weight: bold;
        font-size: 20px;
        margin: 0;
        margin-right: 20px;
        color: var(--color4);
    }
    > hr {
        flex-grow: 1;
        margin: 0;
        align-self: flex-end;
        border-top: solid 1px;
    }
}
</style>



// WEBPACK FOOTER //
// section-label.vue?09801eac